import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }).format(v || 0);

const KATEGORILER = [
  { value: 'kira', label: 'Kira', icon: '🏢' },
  { value: 'elektrik', label: 'Elektrik', icon: '⚡' },
  { value: 'su', label: 'Su', icon: '💧' },
  { value: 'internet', label: 'İnternet', icon: '🌐' },
  { value: 'dogalgaz', label: 'Doğalgaz', icon: '🔥' },
  { value: 'maas', label: 'Maaş', icon: '👥' },
  { value: 'tedarikci', label: 'Tedarikçi', icon: '📦' },
  { value: 'reklam', label: 'Reklam', icon: '📢' },
  { value: 'kirtasiye', label: 'Kırtasiye', icon: '📝' },
  { value: 'bakim_onarim', label: 'Bakım/Onarım', icon: '🔧' },
  { value: 'vergi', label: 'Vergi', icon: '🏛️' },
  { value: 'diger', label: 'Diğer', icon: '📌' },
];

// Silme Onay Modalı Bileşeni
function DeleteConfirmModal({ gider, onConfirm, onClose }) {
  const [deleteGrup, setDeleteGrup] = useState(false);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal animate-popIn" style={{ maxWidth: 400, textAlign: 'center', padding: '30px' }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: '50px', marginBottom: '15px' }}>⚠️</div>
        <h3 style={{ color: '#1E3A8A', marginBottom: '10px', fontWeight: 800 }}>Kaydı Sil?</h3>
        <p style={{ color: '#6B7280', fontSize: '0.9rem', marginBottom: '20px' }}>
          <b>{gider.aciklama}</b> başlıklı gider kaydını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.
        </p>

        {gider.grup_id && (
          <div style={{ background: '#FEF2F2', padding: '12px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #FEE2E2', textAlign: 'left' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '0.85rem', color: '#991B1B', fontWeight: 600 }}>
              <input type="checkbox" checked={deleteGrup} onChange={e => setDeleteGrup(e.target.checked)} style={{ width: '18px', height: '18px' }} />
              Bu gruba ait TÜM taksitleri sil
            </label>
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px' }}>
          <button className="btn btn-secondary" style={{ flex: 1 }} onClick={onClose}>Vazgeç</button>
          <button 
            className="btn" 
            style={{ flex: 1, background: '#DC2626', color: 'white', fontWeight: 700 }} 
            onClick={() => onConfirm(gider.id, deleteGrup)}
          >
            Evet, Sil
          </button>
        </div>
      </div>
    </div>
  );
}

function GiderModal({ gider, onSave, onClose }) {
  const [tip, setTip] = useState(gider?.grup_id ? 'planli' : 'tekil'); 
  const formatInitialDate = (dateStr) => {
    if (!dateStr) return new Date().toISOString().slice(0, 10);
    return new Date(dateStr).toISOString().slice(0, 10);
  };

  const [form, setForm] = useState(gider || {
    kategori: 'diger', aciklama: '', tutar: '',
    tarih: formatInitialDate(),
    odeme_yontemi: 'nakit', tedarikci: '', belge_no: '',
    taksit_sayisi: 1
  });

  useEffect(() => {
    if (gider) {
      setForm({ ...gider, tarih: formatInitialDate(gider.tarih) });
    }
  }, [gider]);

  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!form.aciklama || !form.tutar) { toast.error('Açıklama ve tutar zorunlu'); return; }
    setSaving(true);
    try {
      await onSave({ ...form, tip: tip });
    } finally { setSaving(false); }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 540 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title" style={{ color: '#1E3A8A' }}>{gider ? '✏️ Gider Düzenle' : '➕ Yeni Gider Kaydı'}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {!gider && (
          <div style={{ display: 'flex', background: '#F3F4F6', padding: '5px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #E5E7EB' }}>
            {[
              { id: 'tekil', label: 'Tek Seferlik', icon: '📄' },
              { id: 'taksitli', label: 'Taksitli Borç', icon: '💳' },
              { id: 'sabit', label: 'Sabit Gider', icon: '🏠' }
            ].map(t => (
              <button key={t.id} type="button" onClick={() => setTip(t.id)} style={{
                flex: 1, padding: '10px 5px', borderRadius: '8px', border: 0, cursor: 'pointer', transition: 'all 0.2s',
                background: tip === t.id ? '#1D4ED8' : 'transparent',
                color: tip === t.id ? '#FFFFFF' : '#4B5563',
                fontWeight: 700, fontSize: '0.72rem',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'
              }}>
                <span>{t.icon}</span> {t.label}
              </button>
            ))}
          </div>
        )}

        <div className="muh-grid-2">
          <div className="form-group" style={{ gridColumn: '1/-1' }}>
            <label className="form-label" style={{ fontWeight: 700 }}>Açıklama / Gider Adı *</label>
            <input className="form-input" value={form.aciklama} onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label" style={{ fontWeight: 700 }}>Kategori</label>
            <select className="form-input" value={form.kategori} onChange={e => setForm(f => ({ ...f, kategori: e.target.value }))}>
              {KATEGORILER.map(k => <option key={k.value} value={k.value}>{k.icon} {k.label}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label" style={{ fontWeight: 700, color: '#DC2626' }}>{tip === 'tekil' ? 'Tutar (₺)' : 'Toplam Tutar (₺)'} *</label>
            <input className="form-input" type="number" value={form.tutar} onChange={e => setForm(f => ({ ...f, tutar: e.target.value }))} />
          </div>
          {tip !== 'tekil' && !gider && (
            <div className="form-group">
              <label className="form-label" style={{ fontWeight: 700 }}>Taksit/Ay Sayısı</label>
              <input className="form-input" type="number" value={form.taksit_sayisi} onChange={e => setForm(f => ({ ...f, taksit_sayisi: e.target.value }))} />
            </div>
          )}
          <div className="form-group">
            <label className="form-label" style={{ fontWeight: 700 }}>Tarih</label>
            <input className="form-input" type="date" value={form.tarih} onChange={e => setForm(f => ({ ...f, tarih: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label" style={{ fontWeight: 700 }}>Ödeme Yöntemi</label>
            <select className="form-input" value={form.odeme_yontemi} onChange={e => setForm(f => ({ ...f, odeme_yontemi: e.target.value }))}>
              <option value="nakit">💵 Nakit</option>
              <option value="banka_havalesi">🏦 Banka Transferi</option>
              <option value="kredi_karti">💳 Kredi Kartı</option>
            </select>
          </div>
          <div className="form-group" style={{ gridColumn: '1/-1' }}>
            <label className="form-label" style={{ fontWeight: 700 }}>Tedarikçi / Muhatap</label>
            <input className="form-input" value={form.tedarikci} onChange={e => setForm(f => ({ ...f, tedarikci: e.target.value }))} />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24, borderTop: '1px solid #E5E7EB', paddingTop: '16px' }}>
          <button type="button" className="btn btn-ghost" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving} style={{ background: '#1D4ED8' }}>
            {saving ? <div className="spinner" style={{ width: 16, height: 16 }} /> : '💾 Gideri Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}
 

export default function GiderlerPage() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 900);
  const [giderler, setGiderler] = useState([]);
  const [ozet, setOzet] = useState({});
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null); 
  const [filtre, setFiltre] = useState({ kategori: '', tarih_bas: '', tarih_bit: '', tip: '' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      // Filtreleri temizleyip URL parametresine çeviriyoruz
      const cleanFilters = Object.fromEntries(Object.entries(filtre).filter(([, v]) => v));
      const params = new URLSearchParams(cleanFilters).toString();
      
      const r = await axios.get(`/muhasebe/giderler?${params}`);
      if (r.data.success) {
        setGiderler(r.data.data);
        setOzet(r.data.ozet || {});
      }
    } catch (err) {
      console.error("Gider yükleme hatası:", err);
    } finally { setLoading(false); }
    // KRİTİK: filtre state'inin tamamını izlemeli
  }, [filtre]); 

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleSave = async (form) => {
    try {
      if (form.id) {
        await axios.put(`/muhasebe/giderler/${form.id}`, form);
        toast.success('Güncellendi');
      } else if (form.tip === 'tekil') {
        await axios.post('/muhasebe/giderler', form);
        toast.success('Gider eklendi');
      } else {
        await axios.post('/muhasebe/gider-grubu', {
          baslik: form.aciklama,
          toplam_tutar: form.tutar,
          taksit_sayisi: form.taksit_sayisi,
          kategori: form.kategori,
          baslangic_tarihi: form.tarih,
          tip: form.tip,
          odeme_yontemi: form.odeme_yontemi,
          tedarikci: form.tedarikci
        });
        toast.success('Gider planı oluşturuldu');
      }
      setModal(null); load();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const handleConfirmDelete = async (id, tumGrup) => {
    try {
      let url = `/muhasebe/giderler/${id}`;
      if (tumGrup) url += "?tumGrup=true";
      const r = await axios.delete(url);
      if (r.data.success) {
        toast.success('Silindi');
        setDeleteConfirm(null);
        load();
      }
    } catch { toast.error('Silinemedi'); }
  };

  const handleExcelIndir = () => {
    // Filtreli haliyle Excel URL'ini oluştur
    const cleanFilters = Object.fromEntries(Object.entries(filtre).filter(([, v]) => v));
    const params = new URLSearchParams(cleanFilters).toString();
    window.open(`${axios.defaults.baseURL}/muhasebe/gider-excel?${params}`, '_blank');
  };

  const kat = KATEGORILER.reduce((a, k) => ({ ...a, [k.value]: k }), {});

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="section-header">
        <div>
          <h2 style={{ fontWeight: 900 }}>📉 Gider Yönetimi</h2>
          <div className="section-subtitle">{ozet.sayi || 0} kayıt · Toplam: <b>{TL(ozet.toplam)}</b></div>
        </div>
        <div className="muh-filter-row">
          <button className="btn btn-secondary" style={{ color: '#1D4ED8', borderColor: '#1D4ED8', width: isMobile ? '100%' : 'auto', justifyContent: isMobile ? 'center' : 'flex-start' }} onClick={handleExcelIndir}>📥 Excel Raporu</button>
          <button className="btn btn-primary" style={{ background: '#1D4ED8', width: isMobile ? '100%' : 'auto', justifyContent: isMobile ? 'center' : 'flex-start' }} onClick={() => setModal('yeni')}>+ Gider Ekle</button>
        </div>
      </div>

      <div className="card" style={{ padding: '12px 16px' }}>
        <div className="muh-filter-row" style={{ alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--text-muted)' }}>Gider Tipi</label>
            <select className="form-input" style={{ width: isMobile ? '100%' : 180 }} value={filtre.tip}
              onChange={e => setFiltre(f => ({ ...f, tip: e.target.value }))}>
              <option value="">📂 Tüm Tipler</option>
              <option value="tekil">📄 Tek Seferlik</option>
              <option value="taksitli">💳 Taksitli Borçlar</option>
              <option value="sabit">🏠 Sabit Giderler</option>
            </select>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--text-muted)' }}>Kategori</label>
            <select className="form-input" style={{ width: isMobile ? '100%' : 180 }} value={filtre.kategori}
              onChange={e => setFiltre(f => ({ ...f, kategori: e.target.value }))}>
              <option value="">🏷️ Tüm Kategoriler</option>
              {KATEGORILER.map(k => <option key={k.value} value={k.value}>{k.icon} {k.label}</option>)}
            </select>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--text-muted)' }}>Başlangıç</label>
            <input className="form-input" type="date" style={{ width: isMobile ? '100%' : 150 }} value={filtre.tarih_bas}
              onChange={e => setFiltre(f => ({ ...f, tarih_bas: e.target.value }))} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--text-muted)' }}>Bitiş</label>
            <input className="form-input" type="date" style={{ width: isMobile ? '100%' : 150 }} value={filtre.tarih_bit}
              onChange={e => setFiltre(f => ({ ...f, tarih_bit: e.target.value }))} />
          </div>

          <button className="btn btn-ghost btn-sm" style={{ marginTop: '20px', width: isMobile ? '100%' : 'auto', justifyContent: isMobile ? 'center' : 'flex-start' }} onClick={() => setFiltre({ kategori: '', tarih_bas: '', tarih_bit: '', tip: '' })}>
            ✕ Temizle
          </button>
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {loading ? (
            <div className="page-loader" style={{ minHeight: 200 }}><div className="spinner" /></div>
        ) : isMobile ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 12 }}>
            {giderler.map((g, i) => (
              <div key={i} style={{ border: '1px solid var(--border)', borderRadius: 12, padding: 12, background: '#fff', opacity: new Date(g.tarih) > new Date() ? 0.65 : 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                  <div style={{ fontWeight: 800 }}>{g.aciklama}</div>
                  <div style={{ fontWeight: 900, color: '#EF4444' }}>{TL(g.tutar)}</div>
                </div>
                <div style={{ marginTop: 6, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                  {new Date(g.tarih).toLocaleDateString('tr-TR')} · {kat[g.kategori]?.icon} {kat[g.kategori]?.label}
                </div>
                <div style={{ marginTop: 4, fontSize: '0.76rem', color: 'var(--text-muted)' }}>{g.tedarikci || '—'}</div>
                {g.grup_id && (
                  <div style={{ marginTop: 6 }}>
                    <span style={{ fontSize: '0.65rem', padding: '2px 6px', background: '#DBEAFE', color: '#1E40AF', borderRadius: 4, fontWeight: 700 }}>PLANLI</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginTop: 8 }}>
                  <button className="btn btn-ghost btn-sm" onClick={() => setModal(g)}>✏️</button>
                  <button className="btn btn-ghost btn-sm" style={{ color: '#EF4444' }} onClick={() => setDeleteConfirm(g)}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr><th>Tarih</th><th>Kategori</th><th>Açıklama</th><th>Tedarikçi</th><th style={{ textAlign: 'right' }}>Tutar</th><th>İşlem</th></tr>
              </thead>
              <tbody>
                {giderler.map((g, i) => (
                  <tr key={i} style={{ opacity: new Date(g.tarih) > new Date() ? 0.6 : 1 }}>
                    <td>{new Date(g.tarih).toLocaleDateString('tr-TR')}</td>
                    <td>{kat[g.kategori]?.icon} {kat[g.kategori]?.label}</td>
                    <td>
                      {g.aciklama}
                      {g.grup_id && <span style={{ fontSize: '0.65rem', marginLeft: 8, padding: '2px 6px', background: '#DBEAFE', color: '#1E40AF', borderRadius: 4, fontWeight: 700 }}>PLANLI</span>}
                    </td>
                    <td>{g.tedarikci || '—'}</td>
                    <td style={{ textAlign: 'right', fontWeight: 900, color: '#EF4444' }}>{TL(g.tutar)}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                        <button className="btn btn-ghost btn-sm" onClick={() => setModal(g)}>✏️</button>
                        <button className="btn btn-ghost btn-sm" style={{ color: '#EF4444' }} onClick={() => setDeleteConfirm(g)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && <GiderModal gider={modal === 'yeni' ? null : modal} onSave={handleSave} onClose={() => setModal(null)} />}
      {deleteConfirm && <DeleteConfirmModal gider={deleteConfirm} onConfirm={handleConfirmDelete} onClose={() => setDeleteConfirm(null)} />}
    </div>
  );
}
